export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SinisterSelect.vue?vue&type=template&id=fb9989c6"


//////////////////
// WEBPACK FOOTER
// ./src/components/SinisterSelect.vue?vue&type=template&id=fb9989c6
// module id = 1519
// module chunks = 31